import Component from '../../../../../../../../../lib/component';
import template from './calendar.small.header.html';
import './calendar.small.header.scss'
let config = {
    template: template,
    data: {
    },
    actions: {},
    beforeRender(){
    },
    afterRender() {
        // console.log(this.data)
    },
    firstAfterRender() {}
};
let smallCalendarHeader = Component.extend(config);
export default smallCalendarHeader;


// WEBPACK FOOTER //
// app/components/bisystem/canvas/main/cells/cell/calendar/calendar.small/calendar.small.header/calendar.small.header.js